var _defs, _path, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResoConfort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_10",
    "data-name": "Calque 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 263 790.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#e6eaed;}.cls-3{fill:#f7f7f7;}.cls-4{clip-path:url(#clip-path);}.cls-5{clip-path:url(#clip-path-2);}.cls-6{fill:#095f60;}.cls-7{fill:#83c491;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1588.76 1279.01 1585 1786.55 1378.82 1901.38 1382.57 1393.84 1588.76 1279.01"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1588.76 1279.01 1585 1786.55 1378.82 1901.38 1382.57 1393.84 1588.76 1279.01"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "r\xE9so confort") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1615,2013V1235l-263,149,5,519,227-134,1-492,10-7.8V2020C1595,2027,1615,2030,1615,2013Z",
    transform: "translate(-1352 -1235)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "233 42 0.22 172 5 668 232 534 233 42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1521.75,1428.85c.67.5.66,1.8,0,3.05l-36.48,67.27-12.48,23c-.63,1.16-.13,2.15.82,1.62l22.62-12.59a4.26,4.26,0,0,0,1.54-1.65L1523,1463l24.69-45.53c.68-1.25.69-2.55,0-3l-24.23-18.29-24.78-18.71a1.36,1.36,0,0,0-1.52.06L1474.58,1390c-.95.53-1.46,2.08-.85,2.55l12.24,9.24Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1421.41,1487.49c.2-26.79,6.72-56.25,18.41-83.27.65-1.5,2-2.56,3-2.36l12.68,2.61c1,.2,1.21,1.54.58,3-9.55,22.24-14.88,46.66-15,69.08-.16,21.37,4.44,39.48,13,51.27.59.82.29,2.45-.71,3.71l-13,16.53c-1,1.29-2.36,1.69-3,.87-10.42-14.22-16-35.94-15.85-61.45",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1477.86,1457l-.08,11.8,8.27-4.61a3,3,0,0,0,1.37-2.31l.08-10.24Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1477.9,1452.12l9.63-5.36.08-10c0-.86-.6-1.21-1.35-.79l-8.27,4.6Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1473.61,1459.35l-10.82,6-.08,10.24c0,.86.6,1.21,1.35.79l9.46-5.26Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1473.64,1454.49l.09-11.5-9.46,5.27a3,3,0,0,0-1.37,2.31l-.07,10Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1526.81,1522.36l-.08,10.89-4.65,2.59c3.25,1.08,5.12,4,5.09,8.6v1.49l-9.82,5.47v-1.49c.05-7.38-3.26-9.63-8.43-6.74l-15.58,8.67.08-10.89Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1503,1607.24l-.09,10.89c-2,1.09-3.35,4.09-3.37,7.22,0,2.76,1.07,4.16,2.58,3.32,4.91-2.74,2-21.49,14.1-28.2,7.07-3.94,10.75.77,10.69,9.12-.07,9.1-4.57,18-10.59,21.35l.08-10.82c1.76-1,3-3.65,3-6.41,0-2.46-1-3.78-2.46-2.94-4.71,2.62-2,21.53-13.9,28.17-6.68,3.71-11.15-.11-11.08-9.36.07-9.69,4.84-18.88,11.06-22.34",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1509.31,1640.1c10-5.55,17.42-.94,17.33,10.77s-7.68,24.7-17.63,30.25-17.42.93-17.33-10.78,7.68-24.7,17.63-30.24m-.22,29.83a17.18,17.18,0,0,0,8.32-13.92c0-5.37-3.47-7.35-8.18-4.73a17.21,17.21,0,0,0-8.32,13.92c0,5.37,3.47,7.35,8.18,4.73",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1460.14,1557.26c9.95-5.54,17.41-.93,17.33,10.78-.08,10.21-6,21.59-14.09,27.38l.08-11.56a15.59,15.59,0,0,0,4.78-10.68c0-5.37-3.47-7.36-8.18-4.73a17.17,17.17,0,0,0-8.32,13.91c0,3.81,1.85,6,4.65,5.43l-.08,11.56c-8.11,3.26-13.88-1.63-13.8-11.84.08-11.71,7.68-24.71,17.63-30.25",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1459.81,1601.58c10-5.54,17.42-.93,17.33,10.78s-7.68,24.7-17.63,30.24-17.42.94-17.33-10.77,7.68-24.7,17.63-30.25m-.22,29.84a17.21,17.21,0,0,0,8.32-13.92c0-5.37-3.47-7.35-8.18-4.73a17.18,17.18,0,0,0-8.32,13.92c0,5.37,3.47,7.35,8.18,4.73",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1476.17,1638.23l-.08,10.89-3.28,1.82c2.66,1.49,4,4.6,4,9.3a25.55,25.55,0,0,1-12.81,21.61l-21.48,12,.08-10.88,18.27-10.18a13.07,13.07,0,0,0,6.73-11c0-4.69-2.62-6.41-6.75-4.11l-18.13,10.1.08-10.89Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1467.11,1690l0-5.75,8.71-4.84,0,5.74,2.22-1.24c7.86-4.38,11.88-1.57,11.81,8.28l0,4.7-8.71,4.85,0-3.66c0-3.28-1.46-4.23-4.21-2.7l-1.18.66-.06,8.27-8.71,4.85.06-8.27-24.68,13.74.08-10.89Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1459,1715.84c10-5.54,17.41-.93,17.32,10.77s-7.68,24.71-17.63,30.25-17.41.93-17.33-10.77,7.68-24.71,17.64-30.25m-.23,29.83a17.15,17.15,0,0,0,8.32-13.91c0-5.37-3.46-7.36-8.18-4.73a17.17,17.17,0,0,0-8.32,13.91c0,5.37,3.47,7.36,8.18,4.73",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1475.32,1752.48l-.08,10.89-4.65,2.59c3.25,1.09,5.12,4,5.09,8.61v1.49l-9.82,5.47V1780c.05-7.39-3.26-9.63-8.43-6.75l-15.58,8.68.08-10.89Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1452.54,1800.08l13.81-7.69.05-5.67,8.7-4.85,0,3.13q0,3.13,2.73,1.6l6-3.35-.08,10.29-8.77,4.89-.06,8.27-8.71,4.85.06-8.28-12.24,6.82a7.39,7.39,0,0,0-3.77,6.56l0,3.8-8.71,4.85,0-5.45c.07-9,3.83-15.8,11-19.77",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "179.2 333.95 187.72 341.38 187.82 328.56 179.28 323.21 179.2 333.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1503.17,1589.66c-1.61-.71-2.72-2.74-2.7-6a17.79,17.79,0,0,1,6.29-12.71l-.22,29.09a15.77,15.77,0,0,0,2.88-1.31c10.22-5.69,17.75-18.72,17.83-30.35s-7.38-16.32-17.33-10.78-17.54,18.54-17.63,30.32c-.07,9.21,4.29,14.24,10.79,13.56Zm15.9-16.72a17.15,17.15,0,0,1-6.09,12.23l.13-17.67c3.66-.85,6,1.12,6,5.44",
    transform: "translate(-1352 -1235)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResoConfort);
export default __webpack_public_path__ + "static/media/reso_confort.014c23e07042c85a3216f3fde4c878dd.svg";
export { ForwardRef as ReactComponent };